// extracted by mini-css-extract-plugin
export default {"link":"HRefWrap_link__7cBWd"};